import * as React from 'react';

import { IFileFieldValue } from '../../../../types/file';
import { FileView } from '../FileView';

import * as styles from './styles.css';

export interface IFileListViewProps {
  list: IFileFieldValue[];

  onDelete(id: number): void;
}

export const FileListView: React.FC<IFileListViewProps> = props => {
  const { list, onDelete } = props;

  return (
    <div className={styles['container']}>
      {list.map(file => (
        <div key={file.id} className={styles['item']}>
          <FileView value={file} onDelete={() => onDelete(file.id)} />
        </div>
      ))}
    </div>
  );
};

FileListView.displayName = 'FileListView';
